/* eslint-disable @typescript-eslint/naming-convention */

import { JobApiModel } from '../api/jobs.api';
import { AppointmentDetailsResponse } from '../api/appointments.api';

export interface AppointmentViewModel {
    id: number;
    name: string;
    jobNumber: string;
    locationId: number;
    customerName: string;
    startTime: Date;
}

export const toJobViewModel = (jobApiModel: JobApiModel): AppointmentViewModel => {
    return {
        id: jobApiModel.job_id,
        name: jobApiModel.job_name,
        jobNumber: jobApiModel.job_number,
        locationId: jobApiModel.location_id,
        customerName: jobApiModel.customer_name,
        startTime: new Date(jobApiModel.job_start_date),
    };
};
export const toAppointmentViewModel = (
    jobApiModel: AppointmentDetailsResponse
): AppointmentViewModel => {
    return {
        id: jobApiModel.id,
        name: jobApiModel.jobType,
        jobNumber: jobApiModel.number,
        locationId: jobApiModel.locationId,
        customerName: jobApiModel.customerName,
        startTime: new Date(jobApiModel.startDate),
    };
};

export interface JobTask {
    id: number;
    name: string;
    code: string;
    quantity: number;
    total: number;
}

export interface JobItemModel {
    job_id: number;
    job_type: string;
    job_start_date: string;
    job_duration: string;
    job_invoice_total: number;
    job_summary: string;
    technician: string;
    tasks: JobTask[];
}

export interface JobListModel {
    jobs: JobItemModel[];
}
